import { render } from "./UserContractsForm.vue?vue&type=template&id=3ed587b6"
import script from "./UserContractsForm.vue?vue&type=script&lang=js"
export * from "./UserContractsForm.vue?vue&type=script&lang=js"

import "./UserContractsForm.vue?vue&type=style&index=0&id=3ed587b6&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__